import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import moment from 'moment'
Vue.prototype.moment = moment
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

// vue-js-modal
import VModal from 'vue-js-modal'
Vue.use(VModal)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuesax Admin Filters
import './filters/filters'

// subscriber
require('./store/subscriber') //Adds the Bearer token to the headers from local storage

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
//import 'prismjs/themes/prism-tomorrow.css'

import 'prismjs'

// Feather font icon
require('./assets/css/iconfont.css')

Axios.defaults.baseURL = 'https://lemonspaces.com/api' //UNCOMMENT THIS ON PRODUCTION
Axios.defaults.withCredentials = true;

Vue.config.productionTip = false

window.VeeValidate = require('vee-validate');
Vue.use(window.VeeValidate);

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});
